export default {
    API_ENDPOINT: 'https://obscure-harbor-01108.herokuapp.com',
    API_KEY: process.env.REACT_APP_API_KEY
}